// Recursive secret scrubber for Webex Connect export bundles.
//
// Node method responses embed `client_secret`, OAuth `access_token`,
// `jwtSecretKey`, `securedKey`, etc. in plaintext — including inside the
// `extraparams` field, which is itself a stringified JSON blob. This util
// walks the structure (parsing nested JSON strings where it finds them) and
// replaces every match with a placeholder, then re-serialises.

const SECRET_KEYS = new Set([
  'client_secret',
  'access_token',
  'refresh_token',
  'jwtSecretKey',
  'jwtServiceId',
  'securedKey',
  'secured_key',
  'secret_key',
  'password',
  'api_key',
  'apiKey',
  'hubSecrete',
  'hubSecret',
  'accessToken',
  'access_token_api_response',
]);

const PLACEHOLDER = '__SCRUBBED__';

function scrubValue(value) {
  if (value == null) return value;
  if (typeof value === 'string') {
    return scrubMaybeJsonString(value);
  }
  if (Array.isArray(value)) {
    return value.map(scrubValue);
  }
  if (typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (SECRET_KEYS.has(k)) {
        out[k] = typeof v === 'string' ? PLACEHOLDER : v == null ? v : PLACEHOLDER;
      } else {
        out[k] = scrubValue(v);
      }
    }
    return out;
  }
  return value;
}

// Many Connect responses tuck sub-structures into stringified JSON (e.g.
// `extraparams` on integrations and nodemethod details). Detect, parse,
// scrub, re-stringify.
function scrubMaybeJsonString(str) {
  if (str.length < 2) return str;
  const trimmed = str.trim();
  if (
    !(
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']'))
    )
  ) {
    return str;
  }
  let parsed;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return str;
  }
  const scrubbed = scrubValue(parsed);
  return JSON.stringify(scrubbed);
}

export function scrubBundle(bundle) {
  return scrubValue(bundle);
}

export const SCRUB_PLACEHOLDER = PLACEHOLDER;
